import './barcode.js';

function injectBarCodes() {
    $('.inject-barcode').each(function() {
        // @ts-ignore
        $(this).barcode($(this).text(), "code128", {
            barWidth: 1,
            barHeight: 60
        });
        $(this).removeClass('hide');
    });
}

$(() => {
    injectBarCodes();
})